export default __webpack_public_path__ + "static/media/recycle_bin.31022a67.png";